module.exports = __webpack_public_path__ + "static/media/bank_details.7fc44da1.svg";